import { render, staticRenderFns } from "./tagsMini.vue?vue&type=template&id=1c34a9cb&scoped=true&"
import script from "./tagsMini.vue?vue&type=script&lang=js&"
export * from "./tagsMini.vue?vue&type=script&lang=js&"
import style0 from "./tagsMini.vue?vue&type=style&index=0&id=1c34a9cb&scoped=true&lang=css&"
import style1 from "./tagsMini.vue?vue&type=style&index=1&id=1c34a9cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34a9cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VChip,VIcon,VList,VListItem,VMenu,VTextField})
